angular.module('psModule').factory('CounselingSessionService', function($resource) {
        return $resource('/ps/api/counselingsession/:resource', {}, {
            saveFundChange: {method: 'POST', params: {resource: 'fundchange'}}
        });
    });
